var mod = angular.module('clientDashboardApp.admin.accounts', [

  // dependencies for accounts-service, which looks up account entities when deleting
  'clientDashboardApp.admin.locations.locationsManagerService',
  'clientDashboardApp.admin.users.userManagerService',
  'clientDashboardApp.admin.groups.groupsService'
]);
require('./accounts-service').default(mod);
require('./accountSelection-directive')(mod);
require('./accountsManager')(mod);
require('./confirmDeleteAccountCtrl')(mod);
require('./nonGlobalAccountSelection')(mod);
require('./editor/accountsEditor')(mod);
require('./accountSelector')(mod);

